import { render, staticRenderFns } from "./VimeoPlayerComponent.vue?vue&type=template&id=5d2d0fd0&"
import script from "./VimeoPlayerComponent.vue?vue&type=script&lang=ts&"
export * from "./VimeoPlayerComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports